export default __webpack_public_path__ + "static/media/047-rocket.44399641.svg";